/** Min column width for label + filter + sort; fits ~12ch title at text-xs. */
export const TABLE_LABELED_COLUMN_MIN_SIZE = 216

export const TABLE_HEADER_TITLE_MIN_CHARS = 12

/** Filter + sort controls beside the title (rem). */
export const TABLE_HEADER_CONTROLS_WIDTH_REM = 4

export function resolveTableColumnWidth(column: {
  getSize: () => number
  columnDef: { minSize?: number }
}): number {
  const size = column.getSize()
  const min = column.columnDef.minSize
  return typeof min === "number" ? Math.max(size, min) : size
}
